var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoorClosedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 62,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  fillRule: "evenodd",
  d: "M18 8a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-2a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4zm-2 3a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1zM32 8a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4h-2a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4zm-2 3a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M41.71 20.32a1.17 1.17 0 0 1-.023 1.53l-1.865 2.042h5.177c.557 0 1.001.486 1.001 1.096s-.444 1.095-1 1.095h-5.178l1.865 2.042c.387.423.387 1.095.023 1.53a.94.94 0 0 1-1.433.026L36 25l4.277-4.68a.94.94 0 0 1 1.433.024zM6.29 20.32a1.17 1.17 0 0 0 .023 1.53l1.865 2.042H3.001c-.557 0-1.001.486-1.001 1.096s.444 1.095 1.001 1.095h5.177l-1.865 2.042c-.387.423-.387 1.095-.023 1.53a.94.94 0 0 0 1.433.026L12 25l-4.277-4.68a.94.94 0 0 0-1.433.024z"
})));
export default SvgDoorClosedIcon;